import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import LegacyPratusTable, {
  LegacySelectRowConfig,
} from 'components/DesignSystems/PratusTable/LegacyPratusTable';
import { RosterEntry } from 'components/IAP/hooks/incidentRoster/incidentRoster.types';

export default function CalendarEventAddAttendeeDialog({
  incidentRoster,
  incidentMembersToAttend,
  setIncidentMembersToAttend,
  onClose,
}: {
  incidentRoster: RosterEntry[];
  incidentMembersToAttend: string[];
  setIncidentMembersToAttend: (members: string[]) => void;
  onClose: () => void;
}) {
  const [selectedMembers, setSelectedMembers] = useState(
    incidentRoster.filter((member) =>
      incidentMembersToAttend.includes(member.userId)
    )
  );

  const allColumn = [
    {
      dataField: 'emailAddress',
      text: 'Email Address',
      sort: true,
      headerAttrs: { title: 'Sort By:' },
      attrs: { title: 'Member Email' },
    },
    {
      dataField: 'userName',
      text: 'Member Name',
      sort: true,
      attrs: { title: 'Member Name' },
    },
    {
      dataField: 'incidentSeat',
      text: 'Incident Seat',
      sort: true,
      attrs: { title: 'Incident Seat' },
    },
  ];

  const selectRow: LegacySelectRowConfig<RosterEntry> = {
    mode: 'checkbox',
    clickToSelect: true,
    hideSelectAll: false,
    selected: selectedMembers.map((item) => item.userId),
    onSelect: (row) => {
      let selection = selectedMembers.map((i) => i.userId);
      if (selection.includes(row.userId)) {
        selection = selection.filter((i) => i !== row.userId);
      } else {
        selection.push(row.userId);
      }
      setSelectedMembers(
        incidentRoster.filter((item) => selection.includes(item.userId))
      );
    },
    onSelectAll: (_isSelected, rows) => {
      let selection = selectedMembers.map((i) => i.userId);
      rows.forEach((row) => {
        if (selection.includes(row.userId)) {
          selection = selection.filter((i) => i !== row.userId);
        } else {
          selection.push(row.userId);
        }
      });
      setSelectedMembers(
        incidentRoster.filter((item) => selection.includes(item.userId))
      );
    },
  };

  const onAddMembersClick = () => {
    setIncidentMembersToAttend(
      selectedMembers.map((member: any) => member.userId)
    );

    onClose();
  };

  return (
    <Modal
      show={true}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>Add New Attendees</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>Select Incident Members</h5>
        <LegacyPratusTable
          keyField={'userId'}
          rows={incidentRoster.map((member) => ({
            ...member,
            incidentSeat: member.incidentPositions
              ?.map((p) => p.positionName)
              .toSorted((a, b) => a.localeCompare(b))
              .join(', '),
          }))}
          columns={allColumn}
          selectRow={selectRow}
          hasPagination={true}
          paginationPerPageItem={10}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className="button-group">
          <StylishNewButton
            type="button"
            className="button--primary"
            onClick={onAddMembersClick}
          >
            Add Attendees
          </StylishNewButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
